import React from 'react';
import { Link } from 'react-scroll';

export const Faq = () => {
	return (
		<main role="main" className="view h-auto">
			<h1 className="sr-only visually-hidden">Assist@: Faqs</h1>
			<div className="container-fluid container-hd faqs-layout px-sm">
				<aside className="faqs-aside">
					<h1 className="sr-only visually-hidden">Faqs: Sidebar</h1>
					<ul className="list-unstyled mb-0 py-3 pt-md-1 sticky-top">
						<li className="mb-xs lh-copy">
							<Link className="text-uppercase font-weight-bold ls-n1 fs-3" activeClass="o-100 text-secondary" role="button" spy={true} hashSpy={true} smooth={true} offset={-100} duration={150} to="header">
								FAQ
							</Link>
						</li>
						<hr className="mt-0" />
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="INVITATION">
								Je n’ai pas reçu le mail d’invitation à la complétude de mon dossier
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="VERIFICATION">
								Je n’ai pas reçu mon code de vérification par SMS/email.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONNEXION">
								Je n’arrive pas à me connecter sur mon espace alors que j’ai renseigné les bonnes informations de connexion.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PASSWORD">
								J’ai oublié mon mot de passe. Que faire ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="PROPRIETES">
								J’ai plusieurs propriétés, lesquelles choisir lors de la création de mon dossier ?
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="FILE_ERROR">
								J'ai un message d'erreur suite au dépôt de l'acte de décès.
							</Link>
						</li>
						<li className="mb-xs lh-copy">
							<Link className="o-60 h5 my-auto" activeClass="o-100 text-secondary font-weight-bold" role="button" spy={true} hashSpy={true} smooth={true} offset={-30} duration={150} to="CONTACT">
								Vous ne trouvez pas la réponse à votre question ?
							</Link>
						</li>
					</ul>
				</aside>
				<section className="faqs-main pb-lg" id="detailPrivacy">
					<header className="block" id="header">
						<div className="display-4 font-weight-bold ls-n1">FAQ</div>
						<p className="text-muted lh-copy mb-0">
							Version à jour au <span className="text-underline text-dark"> 24/05/2024 </span>
						</p>
						<hr className="mb-0" />
					</header>
					<article className="block pb-5" id="INVITATION">
						<h2 className="text-uppercase font-weight-demi mt-4">Je n’ai pas reçu le mail d’invitation à la complétude de mon dossier</h2>
						<p className="mb-0">Si vous n’avez pas reçu le mail de première connexion, pensez à vérifier vos SPAM. Si ce n’est pas le cas, contactez votre prestataire ou contactez-nous.</p>
					</article>
					<article className="block pb-5" id="VERIFICATION">
						<h2 className="text-uppercase font-weight-demi">Je n’ai pas reçu mon code de vérification par SMS/email.</h2>
						<p className="mb-0">Si vous n’avez pas reçu votre code de vérification, vérifiez vos informations de connexion (numéro de téléphone/email et mot de passe). Vous pouvez afficher le mot de passe en cliquant sur l'œil pour le vérifier. Si toutes vos informations sont correctes, contactez-nous.</p>
					</article>
					<article className="block pb-5" id="CONNEXION">
						<h2 className="text-uppercase font-weight-demi">Je n’arrive pas à me connecter sur mon espace alors que j’ai renseigné les bonnes informations de connexion.</h2>
						<p className="mb-0">
							Si vous ne parvenez pas à vous connecter, pensez à vérifier vos informations de connexion et à cliquer sur l'œil pour visualiser votre mot de passe. Il se peut que votre clavier soit en majuscules/minuscules et que votre clavier numérique soit verrouillé. Si vous ne parvenez toujours pas à vous connecter,
							vous pouvez modifier votre mot de passe en cliquant sur “mot de passe oublié”. Sinon, contactez-nous.
						</p>
					</article>
					<article className="block pb-5" id="PASSWORD">
						<h2 className="text-uppercase font-weight-demi">J’ai oublié mon mot de passe. Que faire ?</h2>
						<p className="mb-0">Si vous avez perdu votre mot de passe il vous suffit de cliquer sur 'Mot de passe oublié' sur la page de connexion. Suivez ensuite les instructions pour réinitialiser votre mot de passe et accéder à votre compte en toute sécurité.</p>
					</article>
					<article className="block pb-5" id="PROPRIETES">
						<h2 className="text-uppercase font-weight-demi">J’ai plusieurs propriétés, lesquelles choisir lors de la création de mon dossier ?</h2>
						<p className="mb-0">Lors de la création de votre dossier, vous devez uniquement renseigner votre résidence principale mais vous pouvez ajouter toutes vos références de contrats dans les organismes (exemple : EDF, fournisseurs de gaz, eau…).</p>
					</article>
					<article className="block pb-5" id="FILE_ERROR">
						<h2 className="text-uppercase font-weight-demi">J'ai un message d'erreur suite au dépôt de l'acte de décès.</h2>
						<p className="mb-3">Le message indique que le document chargé n'est pas lisible par la plateforme.</p>
						<p className="mb-2">Nous vous recommandons de :</p>
						<ol className="mb-3">
							<li className="mb-2">Supprimer le document depuis votre espace,</li>
							<li className="mb-2">L'ouvrir sur votre ordinateur, puis l'enregistrer sous au format PDF,</li>
							<li className="mb-2">Réimporter le fichier sur la plateforme, puis passer à l'étape suivante.</li>
						</ol>
						<p className="mb-0">
							Si le problème persiste, contactez notre équipe support à l'adresse suivante :{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:contact@assistarobase.fr">
								contact@assistarobase.fr
							</a>
						</p>
					</article>
					<article className="block pb-lg" id="CONTACT">
						<h2 className="text-uppercase font-weight-demi mt-4">Vous ne trouvez pas la réponse à votre question ?</h2>
						<p className="mb-2">
							Contactez-nous :{" "}
							<a className="text-info btn-link font-weight-bold" target="blank" href="mailto:contact@assistarobase.fr">
								contact@assistarobase.fr
							</a>
						</p>
					</article>
				</section>
			</div>
		</main>
	);
}